import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Loader } from '@components/Loader';
import vendorLogo from '@assets/crash/logo-vendor.svg';
import vendorLogoSimple from '@assets/crash/logo-vendor-simple.svg';
import nineCasino from '@assets/crash/ninecasino.svg';
import betonred from '@assets/crash/betonred.svg';
import bruno from '@assets/crash/bruno.svg';
import leo from '@assets/crash/leo.svg';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { GameModes } from 'types/enums';
import { useStore } from '@hooks';

import ProvModule from '@pages/provider1/ProvModule';
import { primaryDark } from '@styles/colors';
import { retry } from '@helpers';

const CrashMultiplayer = lazy(() => retry(() => import('@pages/crash-multiplayer')));
const DoubleMultiplayer = lazy(() => retry(() => import('@pages/double-multiplayer')));
const TowerMultiplayer = lazy(() => retry(() => import('@pages/tower-multiplayer')));
const JackpotMultiplayer = lazy(() => retry(() => import('@pages/jackpot-multiplayer')));
const HiloMultiplayer = lazy(() => retry(() => import('@pages/hilo-multiplayer')));
const FruitsMultiplayer = lazy(() => retry(() => import('@pages/fruits-multiplayer')));
const TeenPattiExpress = lazy(() => retry(() => import('@pages/teen-patti-express')));
const LudoMultiplayer = lazy(() => retry(() => import('@pages/ludo-multiplayer')));
const DragonTiger = lazy(() => retry(() => import('@pages/dragon-tiger')));
const Rummy = lazy(() => retry(() => import('@pages/rummy')));
const Diver = lazy(() => retry(() => import('@pages/diver')));
const NewDouble = lazy(() => retry(() => import('@pages/new-double')));
const NewHilo = lazy(() => retry(() => import('@pages/new-hilo')));
const NewDice = lazy(() => retry(() => import('@pages/new-dice')));
const NewTower = lazy(() => retry(() => import('@pages/new-tower')));

function getLoader(operatorId?: string) {
    switch (operatorId) {
        case 'bc50b74c-fc7a-4f09-ac06-5b5d47b062f8':
            return { logo: nineCasino, background: '#141d3a' };
        case '85b3e86b-a74b-45ce-af4e-f4f2afa358ac':
            return { logo: leo, background: '#191824' };
        case '7cc0292b-7f37-4a25-8f80-64b793783471':
            return { logo: betonred, background: '#252626' };
        case '7d0a08aa-039b-4601-9963-7886c6513807':
            return { logo: betonred, background: '#252626' };
        case '313d7ae7-2da0-4fb8-8cee-0980d0e8f6b6':
            return { logo: bruno, background: '#292d5c' };
        default:
            return { logo: __WHITELABEL__ ? vendorLogoSimple : vendorLogo, background: primaryDark };
    }
}

const Pages = () => {
    const [appLaunch, setAppLaunch] = useState(true);
    const { userStore } = useStore();

    const loaderLogo = getLoader(new URL(window.location.href).searchParams.get('operator') ?? 'default');

    useEffect(() => {
        (async () => {
            await userStore.instance();
            setAppLaunch(false);
        })();
    }, []);

    const comp = () => {
        const url = new URL(window.location.href);
        const firstDot = url.host.indexOf('.');
        url.host = 'aga' + url.host.slice(firstDot);
        url.pathname = '';
        window.open(url.toString(), '_self');
        return null;
    };

    const getGamePath = (game = '') => `/api/modes/${game}/game/`;

    return (
        <>
            {appLaunch ? (
                <Loader logo={loaderLogo} />
            ) : (
                <Router>
                    <Suspense fallback={<Loader logo={loaderLogo} />}>
                        <Switch>
                            <Route
                                path={getGamePath(GameModes.CRASH)}
                                children={<CrashMultiplayer logo={loaderLogo} />}
                            />
                            <Route
                                path={getGamePath(GameModes.DOUBLE)}
                                children={<DoubleMultiplayer logo={loaderLogo} />}
                            />
                            <Route path={getGamePath('wheel')} children={<DoubleMultiplayer logo={loaderLogo} />} />
                            <Route
                                path={getGamePath(GameModes.TOWER)}
                                children={<TowerMultiplayer logo={loaderLogo} />}
                            />
                            <Route
                                path={getGamePath(GameModes.JACKPOT)}
                                children={<JackpotMultiplayer logo={loaderLogo} />}
                            />
                            <Route
                                path={getGamePath(GameModes.CRYPTOS)}
                                children={<FruitsMultiplayer logo={loaderLogo} />}
                            />
                            <Route
                                path={getGamePath(GameModes.HILO)}
                                children={<HiloMultiplayer logo={loaderLogo} />}
                            />
                            <Route
                                path={getGamePath(GameModes.TEEN_PATTI_EXPRESS)}
                                children={<TeenPattiExpress logo={loaderLogo} />}
                            />
                            <Route
                                path={getGamePath(GameModes.DRAGON_TIGER)}
                                children={<DragonTiger logo={loaderLogo} />}
                            />
                            <Route path={getGamePath('prov1_plinko')} children={<ProvModule />} />
                            <Route path={getGamePath('agario')}>{comp}</Route>
                            <Route
                                path={getGamePath(GameModes.LUDO)}
                                children={<LudoMultiplayer logo={loaderLogo} />}
                            />
                            <Route path={getGamePath(GameModes.RUMMY)} children={<Rummy logo={loaderLogo} />} />
                            <Route path={getGamePath(GameModes.DIVER)} children={<Diver logo={loaderLogo} />} />
                            <Route
                                path={getGamePath(GameModes.NEW_DOUBLE)}
                                children={<NewDouble logo={loaderLogo} />}
                            />
                            <Route path={getGamePath(GameModes.NEW_HILO)} children={<NewHilo logo={loaderLogo} />} />
                            <Route path={getGamePath(GameModes.NEW_TOWER)} children={<NewTower logo={loaderLogo} />} />
                            <Route path={getGamePath('lucky-captain')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('new-crash')} children={<CrashMultiplayer logo={loaderLogo} />} />
                            <Route path={getGamePath(GameModes.NEW_DICE)} children={<NewDice logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-boomerang')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-new-year')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-fast')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-valor')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-v2')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-v3')} children={<Diver logo={loaderLogo} />} />
                            <Route path={getGamePath('diver-v4')} children={<Diver logo={loaderLogo} />} />
                        </Switch>
                    </Suspense>
                </Router>
            )}
        </>
    );
};

export default Pages;
